import {
  Block,
  LabelXSmall,
  Link,
  LinkProps,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { links } from "#/shared/constants"
import { useExploreRoute } from "#/shared/hooks"

const FOOTER_NAVIGATION: LinkProps[] = [
  {
    children: "Terms of Service",
    href: links.TERMS_OF_USE,
  },
  {
    children: "FAQ",
    href: links.MEZO_FAQ,
  },
  {
    children: "Support ",
    href: links.DISCORD_SUPPORT,
  },
  {
    children: "Mezo Docs",
    href: links.DOCS,
  },
]

export default function DashboardFooter() {
  const [css, theme] = useStyletron()
  const isExploreRoute = useExploreRoute()

  const showFooter = isExploreRoute

  if (!showFooter) return null

  return (
    <Block
      as="footer"
      className={css({
        height: "113px",
        padding: theme.sizing.scale800,
        paddingLeft: theme.sizing.scale1600,
        display: "flex",
        alignItems: "center",
        gap: theme.sizing.scale700,
      })}
    >
      {FOOTER_NAVIGATION.map((props) => (
        <Link key={props.href} size="xsmall" target="_blank" {...props} />
      ))}
      <LabelXSmall>©️ 2025 Thesis</LabelXSmall>
    </Block>
  )
}
